<script setup>
import { ref, onMounted } from 'vue'
import { Rive, Fit, Layout } from '@rive-app/canvas'

const emit = defineEmits(['riveLoaded'])
const props = defineProps(['rive', 'titleSvg', 'subtext'])
const canvas = ref(null)

onMounted(() => {
	const rive = new Rive({
		canvas: canvas.value,
		src: props.rive.src,
		autoplay: true,
		layout: new Layout({
			fit: Fit.Cover,
		}),
		stateMachines: 'crownsStateMachine',
		onLoad: () => emit('riveLoaded', true),
	})
})
</script>

<template>
	<div class="fixed flex h-[21.5rem] w-full items-center justify-center bg-crowns-off-black text-white lg:h-[25rem] 2xl:h-[30rem]">
		<img class="mb-5 h-20 xs:h-24 md:h-36 lg:h-48 2xl:mb-10 2xl:h-56" :src="titleSvg" alt="Work" />
	</div>
	<section class="relative h-[17rem] overflow-hidden bg-gradient-to-t from-crowns-off-black via-transparent to-transparent pt-28 xs:h-[17.5rem] md:h-[21.5rem] lg:h-[25rem] 2xl:h-[30rem]">
		<div class="container">
			<div class="relative flex flex-col items-center justify-center gap-5">
				<img class="absolute bottom-0 left-0 hidden w-6 sm:block lg:w-8" src="https://cdn.papercrowns.com/website/images/elements/lockups/papercrowns-reimagine-everything-90.svg" alt="Paper Crowns - Reimagine Everything" />
				<img class="absolute bottom-0 right-0 hidden w-8 sm:block lg:w-12" src="https://cdn.papercrowns.com/website/images/elements/lockups/crowns-2019-90.svg" alt="Paper Crowns, Established 2019" />
				<canvas class="mt-0 h-[7.5rem] w-auto xs:h-[8rem] md:-mt-6 md:h-[12.5rem] lg:h-[16.5rem] 2xl:-mt-14 2xl:h-[22rem]" :height="rive.height" :width="rive.width" ref="canvas" />
				<!-- <img class="h-80" src="https://cdn.papercrowns.com/website/images/elements/lockups/work-etches.png" alt="Gargoyle" /> -->
				<p class="text-center text-sm md:text-base" v-if="subtext">{{ subtext }}</p>
			</div>
		</div>
	</section>
</template>
